import Vue from 'vue'
import store from '@/store'
import authority from '@/utils/authority'

function hideNode (checkAction) {
  return {
    bind (el) {
      if (!checkAction()) {
        el.dataset.hide = '1'
      }
    },
    inserted (el) {
      if (!checkAction()) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  }
}

Vue.directive('root', hideNode(checkRoot))

Vue.directive('group', hideNode(checkGroup))

Vue.directive('workshop', hideNode(checkWorkshop))

Vue.directive('workshop_above', hideNode(checkWorkshopAbove))

function hideNodePermission (permission) {
  Vue.directive(permission, {
    inserted (el) {
      if (!checkHasPermission(permission)) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  })
}

function hideNodePosition (position) {
  Vue.directive(position, {
    inserted (el) {
      if (!checkHasPosition(position)) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  })
}

hideNodePermission(authority.ADD_WORK)
hideNodePermission(authority.DELETE_WORK)

hideNodePosition('TECHNICIAN_PO')
hideNodePosition('CONSULTANT_PO')

function checkRoot () {
  return store.state.user.level === 'ROOT'
}

export function checkGroup () {
  if (checkRoot()) return true
  return store.state.user.level === 'GROUP'
}

function checkWorkshop () {
  if (checkRoot()) return true
  return store.state.user.level === 'WORKSHOP'
}

function checkWorkshopAbove () {
  if (checkRoot() || checkGroup()) return true
  return store.state.user.level === 'WORKSHOP'
}

export function checkHasPermission (permission) {
  if (checkRoot()) return true
  return store.state.user.permissions.indexOf(permission) !== -1
}

export function checkHasPosition (position) {
  return store.state.user.positions.indexOf(position) !== -1
}
